module.exports = __webpack_public_path__ + "img/hr-assembling-machine-1-shadow.dc4238c1.png";